<template>
    <div>
        <rkm-form
            class="login-form"
            ref="form"
            v-if="isLayoutLogin"
            validate-on-submit
            @success="login"
        >
            <h1>Boas vindas ao <span>Conecta<strong>SUS</strong></span></h1>
            <rkm-row class="justify-content-between">
                <template v-if="!$scopedSlots.mensagem">
                    <rkm-col>
                        <h5>Por favor informe seus dados</h5>
                    </rkm-col>

                    <rkm-col cols="auto">
                        <h6>v{{ form.packageJSON.version }}</h6>
                    </rkm-col>
                </template>

                <template v-else>
                    <rkm-col>
                        <slot name="mensagem"></slot>
                    </rkm-col>
                </template>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.login.usuario"
                        name="Usuário"
                        v-model="model.login.usuario"
                    >
                        <rkm-input-group-prepend slot="prepend">
                            <rkm-input-group-text><rkm-icon :icon="['far', 'user-circle']" /></rkm-input-group-text>
                        </rkm-input-group-prepend>
                    </rkm-form-input>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.login.senha"
                        name="Senha"
                        :type="model.mostrarSenha ? 'text' : 'password'"
                        v-model="model.login.senha"
                    >
                        <rkm-input-group-prepend slot="prepend">
                            <rkm-input-group-text><rkm-icon icon="lock" /></rkm-input-group-text>
                        </rkm-input-group-prepend>

                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                <rkm-form-checkbox v-model="model.mostrarSenha">Mostrar senha</rkm-form-checkbox>
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>
            </rkm-row>

            <div class="login-form-actions">
                <rkm-button
                    color="primary"
                    type="submit"
                >
                    Realizar login
                </rkm-button>

                <rkm-button @click.stop="$router.push({ name: 'recuperar-senha', params: { customer: $route.params.customer } })">
                    Esqueci minha senha
                </rkm-button>
            </div>
        </rkm-form>

        <rkm-form
            v-else
            ref="form"
            class="login-form"
        >
            <h1>Alterar Senha</h1>

            <rkm-row class="flex-nowrap justify-content-between">
                <rkm-col>
                    <h5>Para continuar, defina uma nova senha para seu usuário.</h5>
                </rkm-col>
            </rkm-row>

            <rkm-row class="align-items-center">
                <rkm-col>

                    <rkm-form-input
                        :validations="validations.trocaSenha.novaSenha"
                        label="Nova Senha"
                        type="password"
                        v-model="model.trocaSenha.novaSenha"
                    >
                        <rkm-input-group-prepend slot="prepend">
                            <rkm-input-group-text><rkm-icon icon="lock" /></rkm-input-group-text>
                        </rkm-input-group-prepend>
                    </rkm-form-input>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.trocaSenha.novaSenhaConfirmation"
                        label="Confirmar nova senha"
                        type="password"
                        v-model="model.trocaSenha.novaSenhaConfirmation"
                    >
                        <rkm-input-group-prepend slot="prepend">
                            <rkm-input-group-text><rkm-icon icon="lock" /></rkm-input-group-text>
                        </rkm-input-group-prepend>
                    </rkm-form-input>

                </rkm-col>
            </rkm-row>

            <rkm-row class="justify-content-between">
                <rkm-col cols="auto" class="order-2">
                    <rkm-button
                        @click="$refs.form.validate(trocarSenha)"
                        color="primary"
                    >
                        Continuar
                    </rkm-button>
                </rkm-col>

                <rkm-col cols="auto" class="order-1">
                    <rkm-button
                        @click="handleVoltarLogin()"
                    >
                        Voltar ao login
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>
    </div>
</template>

<script>
import packageJSON from '/package.json'
import { mapActions, mapGetters } from 'vuex'
import { repository, error, stringCase } from '@/mixins'

export default {
    created() {
        this.form.packageJSON = packageJSON
        this.repositories.cliente = this.getConectaSusRepository('intranet.cliente')
        this.repositories.autenticacao = this.getConectaSusRepository('administracao.autenticacao')
    },
    mixins: [ repository, error, stringCase ],
    data: () => ({
        form: {
            cliente: null,
            layout: 'login',
            packageJSON: null,
        },
        model: {
            login: {
                usuario: '',
                senha: ''
            },
            trocaSenha: {
                novaSenha: '',
                novaSenhaConfirmation: ''
            },
            mostrarSenha: false,
        },
        repositories: {},
    }),
    computed: {
        isLayoutLogin() {
            return this.form.layout == 'login'
        },
        validations() {
            return {
                login: {
                    usuario: {
                        required: true,
                        min: 3
                    },
                    senha: {
                        required: true,
                        min: 8
                    },
                },
                trocaSenha: {
                    novaSenha: {
                        required: true,
                        senha: true
                    },
                    novaSenhaConfirmation: {
                        required: true,
                        is: this.model.trocaSenha.novaSenha
                    },
                },
            }
        },
    },
    methods: {
        ...mapGetters({
            autenticacao: 'getAutenticacao'
        }),
        ...mapActions([
            'clear',
            'setAutenticacao',
            'setCustomer',
            'setLoading',
            'unsetLoading',
        ]),
        load(customer) {
            this.setLoading()

            this.repositories.cliente.index({link: customer})
                .then(({ data }) => {
                    this.setCustomer(data)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleVoltarLogin() {
            this.model = {
                login: {
                    usuario: '',
                    senha: ''
                },
                trocaSenha: {
                    novaSenha: '',
                    novaSenhaConfirmation: ''
                },
            };
            this.form.layout = 'login'
        },
        login() {

            this.setLoading()

            this.repositories.autenticacao.login(this.model.login)
                .then(({ data }) => {

                    this.setAutenticacao(data)

                    this.unsetLoading()

                    if(data.usuario.trocaSenha) {
                        this.form.layout = 'troca-senha'
                    }else{
                        this.$router.push({ name: 'lotacao' })
                    }
                })
                .catch(error => {

                    this.unsetLoading()
                    this.handleError(error)
                })
        },
        trocarSenha() {

            this.setLoading()

            this.repositories.autenticacao.trocarSenha(
                this.autenticacao().usuario.id,
                this.camelObjectKeysToSnakeRecursive(this.model.trocaSenha)
            )
            .then(() => {

                this.unsetLoading()

                this.$router.push({ name: 'lotacao' })
            })
            .catch(error => {

                this.unsetLoading()
                this.handleError(error)
            })
        },
    },
    mounted() {
        const env = process.env.VUE_APP_ENV
        let customer = null

        if (env === 'production') {
            customer = window.location.hostname.split('.')[0]
        } else {
            customer = this.$route.params.customer
        }

        if(customer) {
            this.clear().then(() => {
                this.load(customer)
            });
        }
    }
}
</script>